export default "__VITE_ASSET__B4sYFWj3__"